const config = {
    razorpay: {
        method: "get",
        baseURL: "https://rzpproxy.herokuapp.com/razorpay/",
        headers: {
            "X-Team": "B",
        },
    },
};

export default config;
